import { render, staticRenderFns } from "./WidgetNotifications.vue?vue&type=template&id=d0053976"
import script from "./WidgetNotifications.vue?vue&type=script&lang=ts"
export * from "./WidgetNotifications.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports